/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { NavLink, HashRouter } from "react-router-dom";
// import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import SvgCmp from "../../../../../app/components/svg/SvgCmp";
import SettingsIcon from "@mui/icons-material/Settings";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import BadgeIcon from "@mui/icons-material/Badge";
import { useDispatch, useSelector } from "react-redux";
import { setStep } from "../../../../../app/redux/activeStep/activeStepAction";
import { getTokenClaims } from "../../../../../app/services/auth.service";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import NotificationImportantOutlinedIcon from "@mui/icons-material/NotificationImportantOutlined";
import { useQueryClient } from "react-query";
import { SALE_ITEM, TABLE_FILTER } from "../../../../../app/config/cacheKey";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import version from "../../../../../../package.json";
import SearchIcon from "@mui/icons-material/Search";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { ISaleItemRequest } from "../../../../../app/models/sale.model";
export function AsideMenuList({
  layoutProps,
  setRefreshQuickCartable,
}: {
  layoutProps: any;
  setRefreshQuickCartable: any;
}) {
  const jsonFile = useSelector((state: any) => state.style);
  const location = useLocation();
  const queryClient = useQueryClient();
  const getMenuItemActive = (url: string, hasSubmenu = false) => {
    const test = checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";

    if (url == "/cartable") {
      setRefreshQuickCartable(true);
    }
    return test;
  };
  const dispatch = useDispatch();
  const handelStep = () => {
    dispatch(setStep({ step: 0 }));
  };

  const canModifyUser = String(getTokenClaims()?.canModifyUser);
  const hasWalletAccess = String(getTokenClaims()?.hasWalletAccess);
  const canRegisterLoan = String(getTokenClaims()?.canRegisterLoan);
  const canRegisterProductOrder = String(
    getTokenClaims()?.canRegisterProductOrder
  );
  const hasWhiteListAccess = String(getTokenClaims()?.hasWhiteListAccess);
  const css = `
  .aside-menu .menu-nav>.menu-item.menu-item-open>.menu-link {
    background: ${jsonFile?.mainColor} !important; 
 }
.aside-menu .menu-nav>.menu-item .menu-submenu .menu-item.menu-item-active>.menu-link {
  background: ${jsonFile?.mainColor} !important; 
};
`;
  return (
    <>
      <style>{css}</style>
      <HashRouter>
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/sale",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/sale">
              <span className="svg-icon menu-icon">
                <SvgCmp src="/media/svg/icons/Design/Cap-2.svg" />
                <ListAltIcon className="iconeSide" />
              </span>
              <span className="menu-text"> فروش</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {/*begin::3 Level*/}
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">فروش</span>
                  </span>
                </li>
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/sale/customerInquiry"
                  )} `}
                  aria-haspopup="true"
                  onClick={() => {
                    queryClient.setQueryData(TABLE_FILTER, null);
                  }}
                >
                  <NavLink className="menu-link" to="/sale/customerInquiry">
                    <i className="menu-bullet menu-bullet-dot">
                      <AddCircleOutlineIcon className="iconeSide" />
                    </i>
                    <span className="menu-text">درخواست جدید</span>
                  </NavLink>
                </li>
                {/*end::1 Level*/}

                {/*begin::2 Level*/}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/sale/openSales"
                  )}`}
                  aria-haspopup="true"
                  onClick={() => {
                    queryClient.setQueryData(TABLE_FILTER, null);
                  }}
                >
                  <NavLink className="menu-link" to="/sale/openSales">
                    <i className="menu-bullet menu-bullet-dot">
                      <ListAltIcon className="iconeSide" />
                    </i>
                    <span className="menu-text">فروش های در جریان</span>
                  </NavLink>
                </li>
                {/*begin::3 Level*/}
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/sale/AwaitedSettelmentSales"
                  )} `}
                  aria-haspopup="true"
                  onClick={() => {
                    queryClient.setQueryData(TABLE_FILTER, null);
                  }}
                >
                  <NavLink
                    className="menu-link"
                    to="/sale/AwaitedSettelmentSales"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <ContentPasteSearchIcon className="iconeSide" />
                    </i>
                    <span className="menu-text">در انتظار تایید فاکتور</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/cartable",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/cartable">
              <span className="svg-icon menu-icon">
                <SvgCmp src="/media/svg/icons/Design/Cap-2.svg" />
                <ContentPasteIcon className="iconeSide" />
              </span>
              <span className="menu-text"> کارتابل</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {/*begin::3 Level*/}
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">کارتابل</span>
                  </span>
                </li>

                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/cartable/AwaitedFactorSales"
                  )} `}
                  aria-haspopup="true"
                  onClick={() => {
                    queryClient.setQueryData(TABLE_FILTER, null);
                  }}
                >
                  <NavLink
                    className="menu-link"
                    to="/cartable/AwaitedFactorSales"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <ListAltIcon className="iconeSide" />
                    </i>
                    <span className="menu-text">در انتظار بارگذاری فاکتور</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/financial",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/financial">
              <span className="svg-icon menu-icon">
                <SvgCmp src="/media/svg/icons/Design/Cap-2.svg" />
                <AttachMoneyIcon className="iconeSide" />
              </span>
              <span className="menu-text"> مالی</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {/*begin::3 Level*/}
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">مالی</span>
                  </span>
                </li>
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/financial/WaitForSettlement"
                  )}`}
                  aria-haspopup="true"
                  onClick={() => {
                    const request = {} as ISaleItemRequest;
                    request.from = "financial";
                    localStorage.setItem(SALE_ITEM, JSON.stringify(request));
                    queryClient.setQueryData(TABLE_FILTER, null);
                  }}
                >
                  <NavLink
                    className="menu-link"
                    to="/financial/WaitForSettlementByCustomer"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <AccountBalanceWalletIcon className="iconeSide" />
                    </i>
                    <span className="menu-text"> کیف پول</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/search",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/search">
              <span className="svg-icon menu-icon">
                <SvgCmp src="/media/svg/icons/Design/Cap-2.svg" />
                <SearchIcon className="iconeSide" />
              </span>
              <span className="menu-text"> جستجو</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {/*begin::3 Level*/}
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">جستجو</span>
                  </span>
                </li>
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/search/searchSalefilesTable"
                  )} `}
                  aria-haspopup="true"
                  onClick={() => {
                    queryClient.setQueryData(TABLE_FILTER, null);
                  }}
                >
                  <NavLink
                    className="menu-link"
                    to="/search/searchSalefilesTable"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <SearchIcon className="iconeSide" />
                    </i>
                    <span className="menu-text">پروندهای فروش</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/facilities",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/facilities">
              <span className="svg-icon menu-icon">
                <SvgCmp src="/media/svg/icons/Design/Cap-2.svg" />
                <img src="/images/facilities.svg" className="iconeSide" />
              </span>
              <span className="menu-text"> تسهیلات</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {/*begin::3 Level*/}
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">تسهیلات</span>
                  </span>
                </li>

                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/facilities/NewFacilitieRequest"
                  )} `}
                  aria-haspopup="true"
                  onClick={() => {
                    queryClient.setQueryData(TABLE_FILTER, null);
                  }}
                >
                  <NavLink
                    className="menu-link"
                    to="/facilities/NewFacilitieRequest"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <AddCircleOutlineIcon className="iconeSide" />
                    </i>
                    <span className="menu-text">درخواست تسهیلات جدید</span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/facilities/FacilitiesInProgress"
                  )} `}
                  aria-haspopup="true"
                  onClick={() => {
                    queryClient.setQueryData(TABLE_FILTER, null);
                  }}
                >
                  <NavLink
                    className="menu-link"
                    to="/facilities/FacilitiesInProgress"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <ListAltIcon className="iconeSide" />
                    </i>
                    <span className="menu-text">فهرست تسهیلات </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </HashRouter>
      {/* end::Menu Nav */}
      <div style={{ position: "fixed", bottom: 0, color: "#716e6e7a" }}>
        v{version.version}
      </div>
    </>
  );
}
